<div class="login_sheet">
  <img src="../../../../assets/images/Logo_Orange_colorless.png" class="logo_login" alt="" />
  <form action="" method="post">
    <div class="notification error" *ngIf="sent">
      {{'Email has been sent' | translate }}
    </div>
    <div class="notification error" *ngIf="errMsg">
      {{ errMsg }}
    </div>
    <div class="notification error" *ngIf="changePassword.newPassword !== changePassword.confirmPassword">
      {{'Passwords do not match' | translate}}
    </div>
    <div class="notification error" *ngIf="changePassword.currentPassword === (changePassword.newPassword || changePassword.confirmPassword)">
      {{'New Password should not match old' | translate}}
    </div>

    <div class="form_group">
      <input type="text" name="usernameEmail" [(ngModel)]="changePassword.usernameEmail" class="with_email_icon"
        placeholder="{{ 'Email' | translate }}" />
    </div>
    <div class="form_group">
      <input type="password" name="currentPassword" [(ngModel)]="changePassword.currentPassword" class="with_lock_icon"
        placeholder="{{ 'Current Password' | translate }}" />
    </div>
    <div class="form_group" [ngStyle]="{'position':'relative'}">
      <i [ngStyle]="{'zIndex':100, 'pointer':'cursor', 'position':'absolute', 'top':'15px', 'right':'20px'}" placement="top" tooltip="Hint: Password must be at least 7 characters long. Password must contain at least one uppercase, lowercase, number and special character. Password must not contain three same consecutive characters." class="fa fa-info"></i>
      <input type="password" name="newPassword" [(ngModel)]="changePassword.newPassword" class="with_lock_icon"
        placeholder="{{ 'New Password' | translate }}" />
    </div>
    <div class="form_group">
      <input type="password" name="confirmPassword" [(ngModel)]="changePassword.confirmPassword" class="with_lock_icon"
        placeholder="{{ 'Repeat Password' | translate }}" />
    </div>

    <div class="form_group">
      <input type="submit" (click)="onSubmit()" [disabled]="loading" [value]="loading ? 'loading...' : 'ENTER' | translate" />
    </div>
    <div class="powered_by">{{ "Copyright" | translate }} d.light {{currentYear}}</div>
    <div class="powered_by">
      <a [routerLink]="['/login']">{{ "Back" | translate }}</a>
    </div>
  </form>
</div>
